import { gql } from '@edreamsodigeo/frontend-api-client';
export const CREATE_SHOPPING_CART = gql`
  mutation createShoppingCart(
    $fareItineraryKey: String!
    $promotedItineraryTypes: [PromotedItineraryType!]
    $resident: Boolean
    $searchId: String!
    $segmentKeys: [String!]!
    $flightNumbers: [String!]!
    $extensions: [Extension!]!
  ) {
    createShoppingCart(
      request: {
        fareItineraryKey: $fareItineraryKey
        promotedItineraryTypes: $promotedItineraryTypes
        resident: $resident
        searchId: $searchId
        segmentKeys: $segmentKeys
        flightNumbers: $flightNumbers
        extensions: $extensions
      }
    ) {
      shoppingCart {
        bookingId
      }
    }
  }
`;
